/**
 * Corporate onboarding – step 6 document upload keys.
 * Share `payloadKey` values with the backend team for FormData / API contract.
 */
export const CORPORATE_DOCUMENT_FIELDS = [
  {
    key: "certificateOfIncorporation",
    payloadKey: "CertificateOfIncorporation",
    documentType: 3,
    documentSubType: 5,
    titleKey: "Certificate of Incorporation",
    instructionKey:
      "Please attach a colour copy of your Certificate of Incorporation.",
    accent: "#7367F0",
    required: true,
  },
  {
    key: "constitutionMemorandumArticles",
    payloadKey: "ConstitutionMemorandumArticles",
    documentType: 4,
    documentSubType: 11,
    titleKey: "Constitution / Memorandum and Articles of Association",
    instructionKey:
      "Please attach your company's Constitution, Memorandum and Articles of Association.",
    accent: "#28C76F",
    required: true,
  },
  {
    key: "registerOfDirectors",
    payloadKey: "RegisterOfDirectors",
    documentType: 4,
    documentSubType: 12,
    titleKey: "Register of Directors",
    instructionKey:
      "Please attach an up-to-date Register of Directors for your company.",
    accent: "#FF9F43",
    required: true,
  },
  {
    key: "registerOfShareholders",
    payloadKey: "RegisterOfShareholders",
    documentType: 4,
    documentSubType: 13,
    titleKey: "Register of Shareholders/Directors (min 20% ownership)",
    instructionKey:
      "Please attach the Register of Shareholders/Directors showing all parties with a minimum of 20% ownership.",
    accent: "#00CFE8",
    required: true,
  },
  {
    key: "latestAuditedFinancialStatement",
    payloadKey: "LatestAuditedFinancialStatement",
    documentType: 4,
    documentSubType: 14,
    titleKey: "Latest Audited Financial Statement",
    instructionKey:
      "Please attach your company's latest audited financial statement.",
    accent: "#EA5455",
    required: true,
  },
  {
    key: "others",
    payloadKey: "Others",
    documentType: 4,
    documentSubType: 10,
    titleKey: "Others",
    instructionKey:
      "Please attach any other supporting corporate documents, if applicable.",
    accent: "#A855F7",
    required: false,
  },
];

export const CORPORATE_DOCUMENT_PAYLOAD_KEYS = CORPORATE_DOCUMENT_FIELDS.map(
  (doc) => doc.payloadKey
);

export const getCorporateDocumentFromResponse = (
  corporateDocuments,
  key,
  payloadKey
) => {
  const value =
    corporateDocuments?.[key] ??
    corporateDocuments?.[payloadKey] ??
    corporateDocuments?.[
      payloadKey.charAt(0).toLowerCase() + payloadKey.slice(1)
    ];

  if (Array.isArray(value)) return value[0] || null;
  if (value && typeof value === "object") return value;
  return null;
};

export const mapCorporateDocumentFromApi = (doc) => {
  if (!doc?.id && !doc?.fileUrlPath) return null;

  return {
    id: doc.id,
    fileUrlPath: doc.fileUrlPath,
    fileName: doc.fileName || doc.fileUrlPath?.split("/").pop(),
    status: doc.status || "PROCESSING",
    documentType: doc.documentType,
    documentSubType: doc.documentSubType,
  };
};
